import { render, staticRenderFns } from "./price-vendor-penalties.vue?vue&type=template&id=a9ff2c26&scoped=true&"
import script from "./price-vendor-penalties.vue?vue&type=script&lang=js&"
export * from "./price-vendor-penalties.vue?vue&type=script&lang=js&"
import style0 from "./price-vendor-penalties.vue?vue&type=style&index=0&id=a9ff2c26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ff2c26",
  null
  
)

export default component.exports